export type SupportedLocale = 'en' | 'zh-CN';
export type LanguagePreference = 'system' | SupportedLocale;

export const isSupportedLocale = (value: string): value is SupportedLocale =>
  value === 'en' || value === 'zh-CN';

export const isLanguagePreference = (value: string): value is LanguagePreference =>
  value === 'system' || isSupportedLocale(value);

export const resolveLocale = (
  preference: LanguagePreference,
  browserLanguages: readonly string[],
): SupportedLocale => {
  if (preference !== 'system') return preference;

  for (const language of browserLanguages) {
    let locale: Intl.Locale;
    try {
      locale = new Intl.Locale(language);
    } catch (error) {
      if (error instanceof RangeError) continue;
      throw error;
    }
    if (locale.language === 'en') return 'en';
    // Likely subtags distinguish bare zh / zh-SG from zh-TW / zh-HK,
    // while an explicit script remains authoritative over the region.
    if (locale.language === 'zh' && locale.maximize().script === 'Hans') return 'zh-CN';
  }
  return 'en';
};
